// extracted by mini-css-extract-plugin
export default {"settingsRow":"activity_skills_settings-module___settingsRow___d2db94c0","settingsElement":"activity_skills_settings-module___settingsElement___a941d97a"};